import {Component, Input, Output,EventEmitter} from '@angular/core';



@Component({

    selector:'generic-info-modal',
    template:`
      <div class="modal" [style.display]="!hide ? 'inline' : 'none'" style="margin : 20px; ">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- header-->
            <div class="modal-header">
                <h4 class="modal-title"><span><img alt="icon" class="appWindow" src="../../../assets/images/091.png"></span>{{title}}</h4>
            </div>
              <div class="modalBodyContainer">
                <div class="modal-body">
                  <!-- Texts -->
                  <div>
                    <table style="width: 100%">
                      <tr>
                        <td *ngIf="statusCode >300"><img class="genericIcon" src="../../assets/images/167.png" alt="Error"></td>
                        <td *ngIf="statusCode!=200 && statusCode < 300"><img class="genericIcon" src="../../assets/images/155.png" alt="warning"></td>
                        <td *ngIf="statusCode==200"><img  src="../../assets/images/Alarm-Tick-icon.png" alt="OK"></td>
                        <td style="align-items: center"><p style="text-align: justify">{{text}}</p></td>
                      </tr>
                    </table>
                  </div>
                </div>
                <!-- footer-->
                <div class="modal-footer ">
                  <button (click)="onOkClicked()" class="btn btn-primary clickable hand" id="submit" type="button"><span
                    class="glyphicon glyphicon-ok"></span> {{'OK' | translate}}
                  </button>
                </div>
              </div>
          </div>
        </div>
      </div>`,
    styles:[`
        .closeX{color:azure;size:25px;}
        .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
        .btn-danger:hover{background-color: #FF2400;}
        .appWindow{height:25px;margin-right:140px;}
        .genericIcon{height:90px;}


        /*new css*/

        .modal-title{margin-top: -6px;}
        .closeBtnH4{margin-top: -3px;}
        .appWindow {
            height: 35px;
        }
        .clientRow{background-color: #D0DFFE;}

        .led{width:22px;}

        .tableHeader{ background-image: url("../../assets/images/blueBack.jpg");}
        th{color:#ffffff;text-align: center;}

        .modalBodyContainer{
          background-color:  #ECE8E5;
        }

        .modal-footer{background-color: #ECE8E5;border-top: groove;}
        .modal-body {
            width: 100%;
            padding: 0;
            overflow-y: auto;
        }
        .modal-body thead {
            position: sticky;
            top:0;
        }
        ::-webkit-scrollbar {
            width: 14px;
            height: 5px;
            background-color: #F5F3F0;
        }
        ::-webkit-scrollbar-thumb {
            height: 6px;
            border: 4px solid rgba(0, 0, 0, 0);
            background-clip: padding-box;
            -webkit-border-radius: 7px;
            background-color:#BACEFF;
            -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
        }
        ::-webkit-scrollbar-button {
            width: 14px;
            height: 14px;
            display: none;
        }
        ::-webkit-scrollbar-corner {
            background-color: transparent;
        }

        .modal-dialog {
            margin: 50px auto auto;
            background-color: #0064FE;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }

        .modal-header {
            height:56px;
            background-image: url("../../assets/images/headerBack.jpg");
            color:  #ECE8E5;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }

        .modal-content {
            border-top-right-radius: 18px;
            border-top-left-radius: 18px;
            background-color: #0064FE;
            padding-left: 3px;
            padding-right: 3px;
            padding-bottom: 3px;
        }

        .closeX {
            color: white;
            size: 25px;
        }

        .btn-outline-danger {
            background-color: #d6462e;
            border-style: solid;
            border-color: white;
            border-width: 2px;
            padding: 0;
        }

        /* .btn-outline-danger:hover {
             width: 32px;
             background-image: url("../../../assets/images/closeBtnHovered.png");
         }*/

        .closeIcon:hover{ width: 32px;background-image: url("../../assets/images/closeBtnHovered.png");}

        .closeIcon{ width: 32px;background-image: url("../../assets/images/closeBtn.png");}
    `]
})

export class GenericModalComponent {
    // the below method is to replace all these inputs.
    @Input('title') title:string;
    @Input('text') text:string;
    @Input('hide') hide = true;
    @Output() OkClick: EventEmitter<any> = new EventEmitter();
    @Input('statusCode') statusCode = 200;

    public toggleModal() {
        this.hide= !this.hide;
    }


    onOkClicked() {
        this.OkClick.emit();
    }

    public defineModal(msg:string,title:string,statusCode:number) {
        this.text = msg;
        this.title = title;
        this.statusCode =  statusCode;
    }

}
